import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Features", href: "#features" },
  { label: "Voices", href: "#voices" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "border-b border-textMuted/15 bg-ink/70 backdrop-blur-xl" : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-5 md:px-10">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-full bg-aqua shadow-[0_0_16px_#00E5FF]" />
          <span className="font-display text-xl font-800 tracking-tight text-textMain">Aqua Fit Coach</span>
        </a>

        <div className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-500 text-textMuted transition-colors duration-200 hover:text-aqua"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href="#join"
          data-testid="nav-cta"
          className="rounded-full border border-textMuted/30 px-5 py-2.5 text-sm font-700 text-textMain transition-colors duration-200 hover:border-aqua hover:text-aqua"
        >
          Join waitlist
        </a>
      </nav>
    </motion.header>
  );
};
